export enum ProcedureTypes {
  Completable = 1,
  PassFailUrgentRepair,
  YesNoNotApplicable,
  MeterReading,
}
